import React from 'react';
import styles from './ConfigureTemplatizedScript.module.scss';
import { SqlRunnerConfiguration } from 'new/components/data_sources/SqlRunnerDatabaseConfigurator/SqlRunnerConfiguration';

export default function ConfigureSqlRunner({
  sourceName,
  sourceDescription,
  onSourceNameChange,
  onSourceDescriptionChange,
  sourceConfig,
  onSourceConfigChanged,
  updateFormData,
  selectedCredentialId,
  selectedConnection,
  connectionMetas,
  sourceConfigFields,
  sourceConfigFieldsList,
  onRequestProbeTree,
  onRequestInitialDBProbeTree,
  onGetProbeSample,
  onGetProbeSampleForTablePreview,
  probeData,
  probeDataFlat,
  probeSample,
  probeError,
  probeTreeLastUpdatedAt,
  isLoadingProbeData,
  isLoadingProbeSample,
  selectedTable,
  onTableSelected,
  setContextualSupport,
  unsetContextualSupport,
  onError,
  sourceBeingEdited = null,
}) {
  const effectiveSourceConfig = {
    ...sourceConfig,
    db_query_mode: 'Query',
  };

  return (
    <div className={`${styles.form_container} ${styles.form_container_full_width}`}>
      <div className={styles.connection_inputs_container}>
        <SqlRunnerConfiguration
          selectedCredentialId={selectedCredentialId}
          selectedConnection={selectedConnection}
          connectionMetas={connectionMetas}
          sourceConfigFields={sourceConfigFields}
          sourceConfig={effectiveSourceConfig}
          sourceBeingEdited={sourceBeingEdited}
          onSourceConfigChanged={onSourceConfigChanged}
          updateFormData={updateFormData}
          onRequestProbeTree={onRequestProbeTree}
          onRequestInitialDBProbeTree={onRequestInitialDBProbeTree}
          onGetProbeSample={onGetProbeSample}
          onGetProbeSampleForTablePreview={onGetProbeSampleForTablePreview}
          probeData={probeData}
          probeDataFlat={probeDataFlat}
          probeSample={probeSample}
          probeError={probeError}
          probeTreeLastUpdatedAt={probeTreeLastUpdatedAt}
          isLoadingProbeData={isLoadingProbeData}
          isLoadingProbeSample={isLoadingProbeSample}
          selectedDatabase={null}
          selectedTable={selectedTable}
          parentDataSet={null}
          parentDataSetSamples={null}
          onTableSelected={onTableSelected}
          setContextualSupport={setContextualSupport}
          unsetContextualSupport={unsetContextualSupport}
          sourceName={sourceName}
          sourceDescription={sourceDescription}
          selectedBucket={null}
          sourceConfigFieldsList={sourceConfigFieldsList}
          onInputChange={(args) => {
            if (args?.property === 'sourceName') onSourceNameChange(args.value);
            else if (args?.property === 'sourceDescription') onSourceDescriptionChange(args.value);
          }}
          selectedConnectionDetails={null}
          visibleFieldData={effectiveSourceConfig}
          goBack={() => {}}
          onSaveAdvancedMode={onSourceConfigChanged}
          onError={onError}
          queryModeOnly
        />
      </div>
    </div>
  );
}
